export default __webpack_public_path__ + "static/media/arrow-right-medium.798871b2.svg";